import { createVanIconComponent } from "./van"

const Idcard = createVanIconComponent("idcard")
export default Idcard
